document.addEventListener('DOMContentLoaded', async () => {
    const EHIStore = window.EHIStore;
    const zipCode = await EHIStore.getItem('zipCode');

    if (!EHIStore || !zipCode) {
        return null;
    }

    const links = document.querySelectorAll('a[data-ehi-zipcode="true"]');
    links.forEach(async (link) => {
        const url = new URL(link.href, window.location.origin);
        const params = url.searchParams;
        params.set('zipCode', zipCode);
        link.href = url.toString();
    });
});